import { Injectable } from '@angular/core';
import {
  CompaniesClient,
  CreateHaulerCommand,
  CreateTruckListCommand,
  DeleteTruckListCommand,
  EditHaulerCommand,
  EditTruckCommand,
  FileResponse,
  HaulersClient,
  HaulerSearchViewModelTotalTypePagedResultResponse,
  HaulerViewModel,
  ICreateHaulerCommand,
  IHaulerViewModel,
  TruckDownloadQuery,
  TrucksClient,
  TruckSearchViewModelTotalTypePagedResultResponse
} from '@services/cleanfill-api/cleanfill-api.generated';
import { AuthService } from '@services/core/auth.service';
// import { IHaulerTotalTypePagedResultResponse } from '@view-models/haulers/hauler';
import { ISearchQuery } from '@view-models/interfaces/search-query';
import { Observable, of } from 'rxjs';
import { concatMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpHaulersService {
  constructor(
    private companiesClient: CompaniesClient,
    private haulersClient: HaulersClient,
    private trucksClient: TrucksClient,
    private authService: AuthService
  ) { }
  getHaulerRequest(id: string): Observable<IHaulerViewModel> {
    return of({});
  }
  getHauler(fillSiteUniqueId: string) {
    return this.haulersClient.getHaulerDetail(fillSiteUniqueId, undefined);
  }
  getHaulerRequests(query: ISearchQuery): Observable<HaulerSearchViewModelTotalTypePagedResultResponse> {
    return this.authService.activeUserLegalEntityUniqueId$.pipe(
      concatMap(uniqueId => {
        return this.companiesClient.haulerSearch(uniqueId, uniqueId, query.Page, query.PageSize, query.SortBy, query.FilterBy, undefined);
      })
    );
  }
  getHaulerRequestsById(clientId: string, query: ISearchQuery): Observable<HaulerSearchViewModelTotalTypePagedResultResponse> {
    return this.companiesClient.haulerSearch(clientId, clientId, query.Page, query.PageSize, query.SortBy, query.FilterBy, undefined);
  }
  getTrucks(query: ISearchQuery, companyUniqueId?: string): Observable<TruckSearchViewModelTotalTypePagedResultResponse> {
    if (companyUniqueId) {
      return this.companiesClient.truckSearch(
        companyUniqueId,
        companyUniqueId,
        query.Page,
        query.PageSize,
        query.SortBy,
        query.FilterBy,
        undefined
      );
    } else {
      return this.authService.activeUserLegalEntityUniqueId$.pipe(
        concatMap(uniqueId => {
          return this.companiesClient.truckSearch(uniqueId, uniqueId, query.Page, query.PageSize, query.SortBy, query.FilterBy, undefined);
        })
      );
    }
  }
  newHaulerRequest(cmd: ICreateHaulerCommand): Observable<HaulerViewModel> {
    const command = new CreateHaulerCommand();
    command.init(cmd);
    return this.haulersClient.createHauler(new Date().getTimezoneOffset().toString(), command);
  }
  createHauler(payload: CreateHaulerCommand): Observable<HaulerViewModel> {
    return this.haulersClient.createHauler(new Date().getTimezoneOffset().toString(), payload);
  }
  downloadBarcodes(body: TruckDownloadQuery): Observable<FileResponse> {
    return this.trucksClient.downloadBarcodes(new Date().getTimezoneOffset().toString(), body);
  }
  deleteHauler(uniqueId: string): Observable<void> {
    return this.haulersClient.deleteHauler(uniqueId, new Date().getTimezoneOffset().toString());
  }
  createTrucks(payload: CreateTruckListCommand): Observable<void> {
    return this.haulersClient.createTrucks(payload.haulerUniqueId, new Date().getTimezoneOffset().toString(), payload);
  }
  // createTruck(payload: CreateTruckCommand): Observable<TruckViewModel> {
  //   return this.haulersClient.createTruck(payload.haulerUniqueId, new Date().getTimezoneOffset().toString(), payload);
  // }
  deleteTruck(uniqueId: string): Observable<void> {
    return this.trucksClient.deleteTruck(uniqueId, undefined);
  }
  getEmailLogs(uniqueId: string): Observable<FileResponse> {
    return this.trucksClient.truckEmailLogs(uniqueId, new Date().getTimezoneOffset().toString());
  }
  deleteTrucks(payload: DeleteTruckListCommand): Observable<void> {
    return this.trucksClient.deleteTrucks(new Date().getTimezoneOffset().toString(), payload);
  }
  editHauler(payload: EditHaulerCommand): Observable<void> {
    return this.haulersClient.editHauler(payload.uniqueId, undefined, payload);
  }
  editTruck(payload: EditTruckCommand): Observable<void> {
    return this.trucksClient.editTruck(payload.uniqueId, undefined, payload);
  }
}
